<template>
    <div class="calendar-wrapper">

        <!-- arrow left -->
        <IconMode>
            <template #default="{ index }">
                <img src="@static/images/icons/aspn_icon/date_picker/arrow_left_web.png" 
                    v-if="['lightWeb','lightWebapp'].includes(index)"
                    class="weekly-calander-arrow" 
                    @click="changeDate('prev')" />
                <img src="@static/images/icons/aspn_icon/date_picker/arrow_left_web_dark.png" 
                    v-else-if="['darkWeb','darkWebapp'].includes(index)"
                    class="weekly-calander-arrow" 
                    @click="changeDate('prev')" />
            </template>
        </IconMode> 
        
        <div class="calendar-blur left"></div>
        <div class="calendar-container weekly-calendar-container" ref="calendarContent">
            <div class="calendar-box" :class="{selected: o.selected}" v-for="(o, index) in calendar" :key="index" @click="selectMatchByDate(o)">
            <span class="calendar-box__week">{{$t(o.day)}}</span>
            <span class="calendar-box__monnth">{{o.date}}<span>{{ addCNCalendarDay }}</span> {{$t(o.month)}}</span>
            </div>
        </div>

        <!-- arrow-right -->
        <IconMode>
            <template #default="{ index }">
                <img src="@static/images/icons/aspn_icon/date_picker/arrow_right_web.png" 
                    v-if="['lightWeb','lightWebapp'].includes(index)"
                    class="weekly-calander-arrow" 
                    @click="changeDate('next')" />
                <img src="@static/images/icons/aspn_icon/date_picker/arrow_right_web_dark.png" 
                    v-else-if="['darkWeb','darkWebapp'].includes(index)"
                    class="weekly-calander-arrow" 
                    @click="changeDate('next')" />
            </template>
        </IconMode> 
        <!-- <img src="../../static/images/icons/aspn_icon/date_picker/arrow_right_web.png" class="weekly-calander-arrow" @click="changeDate('next')"  /> -->
        <div class="calendar-blur right" v-show="!isShowPassDayOnly"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/js/config.js";
import { sharedState } from '../js/sharedState/index'
const TODAY = "TODAY";
export default {
    props: {
        params: {
            type: String
        },
        show: {
            type: Number,
            default: 5
        },
        data: {
            type: Object,
        },
        isShowPassDayOnly: {
            type: Boolean,
            default: false
        }
    },
    watch:{
        params: {
            deep: true,
            handler(newVal,oldVal) {
                this.syncWeeklyCalendar(newVal);
            }
        },
        data: {
            deep: true,
            handler(newVal,oldVal) {
            let isOverWeeklyDateRange = true;

                for(let i = 0; i < this.calendar.length; i++) {
                    if (newVal.isLiveOnlyMatch) {
                        this.calendar[i].selected = false;
                    } else{                   
                        if (newVal.currentDate === this.calendar[i].fullDate) {
                            this.calendar[i].selected = true;
                            isOverWeeklyDateRange = false;               
                        } else {
                            this.calendar[i].selected = false;
                        }    
                        this.$emit('isOverWeeklyDateRange',isOverWeeklyDateRange);
                            
                    }
                }		
            }
        }
    },
    computed: {
        ...mapGetters([
            "currentLocale",
        ]),
        addCNCalendarDay() {
            if (this.cnLocaleList.includes(this.currentLocale)) {
                return "日";
            }
            return;
        },
        currentDate() {
            for(var index in this.calendar) {
                if(this.calendar[index].selected) {
                    return this.calendar[index]
                }
            }
            return {}
        }
    },
    data() {
        return{
            calendar : [],
            currentTodayDate : '',
            cnLocaleList: config.cnLocaleList,
        }
    },
    mounted() {
        this.initCalendar();

        if(!this.isMobile) {
            // mainUpdate trigger watch
            this.$watch(() => sharedState.mainUpdate, (newVal) => {
                // mainLogoClicked = true will update today
                if(sharedState.mainLogoClicked === true) {
                    let fixedTodayDate = new Date()
                    let obj = {
                        selected: true,
                        day: TODAY,
                        month: this.$tools.getMonth(fixedTodayDate.getMonth()),
                        date: fixedTodayDate.getDate()
                    }
    
                    this.$emit('weeklyDateChange', obj)
                    sharedState.mainUpdate = false;
                }
                sharedState.mainLogoClicked = false;
            })
            
            sharedState.mainUpdate = !sharedState.mainUpdate
        }
    },
    methods: {
        // init weekly calendar
        syncWeeklyCalendar(newVal) { // 1
            let isOverWeeklyDateRange = true;

            for(let i=0; i<this.calendar.length; i++) {
                if (newVal === this.calendar[i].fullDate) {
                    this.calendar[i].selected = true;
                    isOverWeeklyDateRange = false;
                } else {
                    this.calendar[i].selected = false;
                }
            }

            this.$emit('isOverWeeklyDateRange',isOverWeeklyDateRange);
        },
        // select weekly date
        selectMatchByDate(o) { // 2
            this.calendar.forEach(x => {
                x.selected = false;
            });
            o.selected = true;
            this.$emit('weeklyDateChange',o)
        },
        // set next day or prev day
        changeDate(type) { // 2
            for(var index in this.calendar) {
                let current = this.calendar[index]
                if(current.selected) {
                    current.selected = false;
                    if(type === 'next') {
                        let next = this.calendar[parseInt(index) + 1]
                        next.selected = true
                        this.$emit('weeklyDateChange',next)
                    } else {
                        let prev = this.calendar[parseInt(index) - 1]
                        prev.selected = true
                        this.$emit('weeklyDateChange', prev)
                    }
                    break;
                }
            }
        },
        // generate weekly calendar
        initCalendar() { // 3
            let isGenerateNextDate = true;
            let isFirstTimeGenerate = true;
            let show = this.show;
            let currentDate = new Date();
            let prevDates = this.getDates(currentDate,show,!isGenerateNextDate, '', isFirstTimeGenerate);
            let nextDates = this.getDates(currentDate,show,isGenerateNextDate, '', isFirstTimeGenerate);
            let fullDates
            
            if (this.isShowPassDayOnly) {
                show = show * 2;
                prevDates = this.getDates(currentDate,show,!isGenerateNextDate, isFirstTimeGenerate);
                fullDates = prevDates.reverse();
            } else {
                prevDates.shift()//remove duplicate today; 
                fullDates = prevDates.reverse().concat(nextDates);
            }
        
            this.calendar = fullDates;     
            let scrollPosition = this.show / 2 * 60;

            if (this.isShowPassDayOnly) {
                scrollPosition = 500;
            }
        
            this.$nextTick(() => {
                this.$refs.calendarContent.scrollTo(scrollPosition, 0)   

            })   
    
        
        },
        // generate prev date and next date at initCalendar
        getDates(startDate,daysToAdd,isGenerateFutureDate,today = '',isFirstTimeGenerate) { // 3.1
            let aryDates = [];
            let fixedTodayDate = new Date()
            for (let i = 0; i <= daysToAdd; i++) {
                // set the weekly will follow selected date to generate
                let currentDate = today ? new Date(today) : new Date();
                if (isGenerateFutureDate) {
                    currentDate.setDate(startDate.getDate() + i);
                } else {
                    currentDate.setDate(startDate.getDate() - i);
                }

                let obj ={};
                let fullDateMonth = currentDate.getMonth()+1;
                let fullDateDate = currentDate.getDate();
                
                if (fullDateMonth < 10) {
                    fullDateMonth = `0${fullDateMonth}`
                }
                if (fullDateDate < 10) {
                    fullDateDate = `0${fullDateDate}`
                }
                obj.selected = false;
                obj.day = this.$tools.getDay(currentDate.getDay());
                obj.month =this.$tools.getMonth(currentDate.getMonth()),
                obj.date = currentDate.getDate();
                if(obj.date === fixedTodayDate.getDate() && currentDate.getMonth() + 1 === fixedTodayDate.getMonth() + 1) {
                    obj.day = TODAY;
                }
                
                obj.fullDate =  `${currentDate.getFullYear()}-${fullDateMonth}-${fullDateDate}`;

                let currentDateObj = new Date(this.currentDate.fullDate)
                if (currentDate.getDate() === fixedTodayDate.getDate() && currentDate.getMonth() === fixedTodayDate.getMonth() && currentDate.getYear() === fixedTodayDate.getYear()) {
                    if (isGenerateFutureDate || this.isShowPassDayOnly) {
                        if(isFirstTimeGenerate) {
                            obj.selected = true;
                        }
                        // obj.day = TODAY;
                    }      
                }
                
                aryDates.push(obj)
                //aryDates.push(DayAsString(currentDate.getDay()) + ", " + currentDate.getDate() + " " + MonthAsString(currentDate.getMonth()) + " " + currentDate.getFullYear());
            }

            return aryDates;
        },
        // get offset different for getFormattedUTC8Date() use
        getOffsetDifference(sourceTimeZone, targetTimeZone, date) { // 4.3
            // get correct offset need use utcDate
            let utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
            
            const sourceOffset = this.getTimeZoneOffset(sourceTimeZone, utcDate);
            const targetOffset = this.getTimeZoneOffset(targetTimeZone, utcDate);
            // calculate utc8 & current offset
            return targetOffset - sourceOffset;
        },
        // calc timezone offset for getOffsetDifference() use
        getTimeZoneOffset(timeZone, date) { // 4.4
            // 创建指定时区的时间格式化器
            const options = { timeZone: timeZone, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            const formatter = new Intl.DateTimeFormat("en-US", options);

            // 解析目标时区时间字符串为 Date 对象
            const parts = formatter.formatToParts(date).reduce((acc, part) => {
                if (part.type !== "literal") acc[part.type] = part.value;
                return acc;
            }, {});

            // 创建目标时区的日期对象
            const targetDate = new Date(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`);

            // 计算偏移：目标时区时间 - UTC 时间
            return (targetDate - date) / 60000; // 返回分钟偏移
        },
        // select weekly date or select calendar picker will trigger this function
        getFormattedUTC8Date(date2) { // 4.2
            let date = new Date(date2); 
            let sourceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // 源时区
            let targetTimeZone = "Asia/Shanghai"; // 目标时区

            // 自动计算偏移
            let offset = this.getOffsetDifference(sourceTimeZone, targetTimeZone, date);
            let adjustedDate = new Date(date.getTime() + offset * 60 * 1000); // 调整时间
            return adjustedDate
        },
        // set new current date and init calendar again 
        setNewCurrentDate(date) { // 4.1
            let adjustedDate = this.getFormattedUTC8Date(date)
            let fullDateMonth = adjustedDate.getMonth()+1;
            let fullDateDate = adjustedDate.getDate();
            
            if (fullDateMonth < 10) {
                fullDateMonth = `0${fullDateMonth}`
            }
            if (fullDateDate < 10) {
                fullDateDate = `0${fullDateDate}`
            }
            this.currentDate.selected = true;
            this.currentDate.day = this.$tools.getDay(adjustedDate.getDay());
            this.currentDate.month =this.$tools.getMonth(adjustedDate.getMonth()),
            this.currentDate.date = adjustedDate.getDate();
            
            this.currentDate.fullDate =  `${adjustedDate.getFullYear()}-${fullDateMonth}-${fullDateDate}`;
            this.initCalendarAgain()
        },
        // generate weekly calendar is not first time
        initCalendarAgain() { // 4.5
            let isGenerateNextDate = true;
            let show = this.show;

            let date = new Date(this.currentDate.fullDate); 
            let sourceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // 源时区
            let targetTimeZone = "Asia/Shanghai"; // 目标时区

            // 自动计算偏移
            let offset = this.getOffsetDifference(sourceTimeZone, targetTimeZone, date);
            let currentDate = new Date(date.getTime() + offset * 60 * 1000); // 调整时间

            // currentDate = new Date(currentDate.getTime() + offset * 60 * 1000); // 调整时间
            let prevDates = this.getDates(currentDate,show,!isGenerateNextDate, this.currentDate.fullDate);
            let nextDates = this.getDates(currentDate,show,isGenerateNextDate, this.currentDate.fullDate);
            let fullDates
            
            if (this.isShowPassDayOnly) {
                show = show * 2;
                prevDates = this.getDates(currentDate,show,!isGenerateNextDate, this.currentDate.fullDate);
                fullDates = prevDates.reverse();
            } else {
                prevDates.shift()//remove duplicate today; 
                
                nextDates[0].selected = true
                fullDates = prevDates.reverse().concat(nextDates);
            }
            this.calendar = fullDates;     
            let scrollPosition = this.show / 2 * 60;

            if (this.isShowPassDayOnly) {
                scrollPosition = 500;
            }
        
            this.$nextTick(() => {
                this.$refs.calendarContent.scrollTo(scrollPosition, 0)   

            })   
        },
        
        
        
        
    }
}
</script>

<style>

.calendar-container{
  display:flex;
}
.calendar-box{
  position: relative;
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color : var(--color-text-default-secondary) !important;
  font-size: .66rem;
  padding: 10.5px 6px;
  /* margin: 0 .3rem; */
  min-width: 3rem;
  cursor:pointer;
  text-align:center;
  border-radius: .3rem;
  /* border-top-left-radius: .3rem; */
  /* border-top-right-radius: .3rem; */
  margin-bottom: .3rem;
  z-index: 1;
}
.calendar-box.selected{
    color: var(--tag-active-text) !important;
  background-color: var(--color-background-brand-default) !important;
}
.calendar-box:hover{
  color: var(--color-background-brand-default) !important;
  /* background-color: var(--color-background-brand-default) !important; */
}
.calendar-box.selected:hover {
    color: var(--tag-active-text) !important;
}

/* .calendar-box.selected::after{
  bottom: -9.5px;
  left: 50%;
  border-style: solid;
  border-image: initial;
  content: " ";
  height: 0px;
  width: 0px;
  position: absolute;
  pointer-events: none;
  border-color: var(--bg-selected) rgba(255, 138, 0, 0) rgba(255, 138, 0, 0) ;
  border-width: 5px 7px;
  margin-left: -7px;
} */

.calendar-box__week{
    font-size: 12px;
    font-family: var(--weight-600);
	letter-spacing: 0.2px;
}   
.calendar-box__monnth{
    font-family: var(--weight-600);
    margin-top: 4px;
    font-size: 12px;
    letter-spacing: 0.2px;
}

@media(max-width: 768px) { /* for test */
  .calendar-blur{
      width: 2rem;
      height: 98%;
      top : 0;
      position: absolute;
      z-index: 2;
  }
  .calendar-blur.left{
      background: linear-gradient(90deg,var(--bg-theme),transparent);
      left: 0;
  }
  .calendar-blur.right{
      background: linear-gradient(90deg,transparent,var(--bg-theme));
      right: 0;
  }
 .calendar-wrapper{
      position: relative;
      width: 15rem;
    
  }  
  .calendar-container{
      overflow-x: auto;
      overflow-y: hidden;
  }
  .calendar-box:hover{
      color :white ;
      background-color: transparent; 
  }

}
</style>

<style scoped>
.calendar-wrapper {
  display: flex;
  align-items: center;
}
.weekly-calander-arrow {
  width: 24px;
  cursor: pointer;
}
.weekly-calander-arrow:first-child { /* left */
  width: 24px;
  height: 24px;
  margin-right: 4px;
}
.weekly-calander-arrow:last-child { /* left */
  width: 24px;
  height: 24px;
  margin-left: 4px;
}
.weekly-calendar-container {
  border-bottom: 0 !important;
}
.weekly-calendar-container .calendar-box {
  margin-bottom: 0;
}
</style>